export default __webpack_public_path__ + "0525955b630c60aa2875d3c3699d72cd.otf";